module.exports = __webpack_public_path__ + "img/13.bb7bf4d.png";